import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { ProgressBar, Button } from "react-bootstrap";
import "swiper/css";

export default function TokenSlide() {
    const now = 60;

    return (
        <>
            <div className="cardBox2 mb-3 overflow-hidden rainbow rounded-0">
                <div className="p-4 tokenBox">
                    <Swiper
                        className="mySwiper"
                        spaceBetween={30}
                    >
                        <SwiperSlide>
                            <div>
                                <div>
                                    <span className="text-primary x-small">
                                        Fundraise Goal
                                    </span>
                                </div>
                                <h3 className="text-black fw-bold my-2">$300,000</h3>
                                <p>Maximum funding goal reached</p>
                            </div>
                            <div className="mb-3">
                                <ProgressBar
                                    // now={(tokenSold / presaleInfiBalance) * 100}
                                    now={`100%`}
                                    label={`${now}%`}
                                    visuallyHidden
                                />
                            </div>
                            <div className="mb-3">
                                <div className="">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">Allocation</span>
                                        <b className="fs-5">$350 - $0</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">
                                            Price Per token
                                        </span>
                                        <b className="fs-5">$0.521</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">ATH ROI</span>
                                        <b className="fs-5">TBA</b>
                                    </div>
                                </div>
                            </div>
                            <Button variant="dark" className="w-100">
                                Buy AXVERSE
                            </Button>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div>
                                <div>
                                    <span className="text-primary x-small">
                                        Fundraise Goal
                                    </span>
                                </div>
                                <h3 className="text-black fw-bold my-2">$300,000</h3>
                                <p>Maximum funding goal reached</p>
                            </div>
                            <div className="mb-3">
                                <ProgressBar
                                    // now={(tokenSold / presaleInfiBalance) * 100}
                                    now={`100%`}
                                    label={`${now}%`}
                                    visuallyHidden
                                />
                            </div>
                            <div className="mb-3">
                                <div className="">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">Allocation</span>
                                        <b className="fs-5">$350 - $0</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">
                                            Price Per token
                                        </span>
                                        <b className="fs-5">$0.521</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">ATH ROI</span>
                                        <b className="fs-5">TBA</b>
                                    </div>
                                </div>
                            </div>
                            <Button variant="dark" className="w-100">
                                Buy AXVERSE
                            </Button>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div>
                                <div>
                                    <span className="text-primary x-small">
                                        Fundraise Goal
                                    </span>
                                </div>
                                <h3 className="text-black fw-bold my-2">$300,000</h3>
                                <p>Maximum funding goal reached</p>
                            </div>
                            <div className="mb-3">
                                <ProgressBar
                                    // now={(tokenSold / presaleInfiBalance) * 100}
                                    now={`100%`}
                                    label={`${now}%`}
                                    visuallyHidden
                                />
                            </div>
                            <div className="mb-3">
                                <div className="">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">Allocation</span>
                                        <b className="fs-5">$350 - $0</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">
                                            Price Per token
                                        </span>
                                        <b className="fs-5">$0.521</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">ATH ROI</span>
                                        <b className="fs-5">TBA</b>
                                    </div>
                                </div>
                            </div>
                            <Button variant="dark" className="w-100">
                                Buy AXVERSE
                            </Button>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div>
                                <div>
                                    <span className="text-primary x-small">
                                        Fundraise Goal
                                    </span>
                                </div>
                                <h3 className="text-black fw-bold my-2">$300,000</h3>
                                <p>Maximum funding goal reached</p>
                            </div>
                            <div className="mb-3">
                                <ProgressBar
                                    // now={(tokenSold / presaleInfiBalance) * 100}
                                    now={`100%`}
                                    label={`${now}%`}
                                    visuallyHidden
                                />
                            </div>
                            <div className="mb-3">
                                <div className="">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">Allocation</span>
                                        <b className="fs-5">$350 - $0</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">
                                            Price Per token
                                        </span>
                                        <b className="fs-5">$0.521</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">ATH ROI</span>
                                        <b className="fs-5">TBA</b>
                                    </div>
                                </div>
                            </div>
                            <Button variant="dark" className="w-100">
                                Buy AXVERSE
                            </Button>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div>
                                <div>
                                    <span className="text-primary x-small">
                                        Fundraise Goal
                                    </span>
                                </div>
                                <h3 className="text-black fw-bold my-2">$300,000</h3>
                                <p>Maximum funding goal reached</p>
                            </div>
                            <div className="mb-3">
                                <ProgressBar
                                    // now={(tokenSold / presaleInfiBalance) * 100}
                                    now={`100%`}
                                    label={`${now}%`}
                                    visuallyHidden
                                />
                            </div>
                            <div className="mb-3">
                                <div className="">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">Allocation</span>
                                        <b className="fs-5">$350 - $0</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">
                                            Price Per token
                                        </span>
                                        <b className="fs-5">$0.521</b>
                                    </div>

                                    <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-grey fs-5">ATH ROI</span>
                                        <b className="fs-5">TBA</b>
                                    </div>
                                </div>
                            </div>
                            <Button variant="dark" className="w-100">
                                Buy AXVERSE
                            </Button>
                        </SwiperSlide>

                    </Swiper>
                </div>
            </div>
        </>
    );
}
